// Regulatory requirement: these states prohibit displaying feelings
// and activities ("effects") on menu filters and product detail pages.
const EFFECTS_DISABLED_STATES = ['washington', 'ohio'];

export function isEffectsDisabledState(
  state: string | undefined | null
): boolean {
  if (!state) return false;
  return EFFECTS_DISABLED_STATES.includes(state.toLowerCase());
}
